import NotActiveLicense from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/notActiveLicense.svg?react';
import NotActiveinitialInfo from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/notActiveinitialInfo.svg?react';
import NotActiveContact from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/notActiveContact.svg?react';
import ActiveContact from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/activeContact.svg?react';
import ActiveinitialInfo from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/activeinitialInfo.svg?react';
import ActiveLicense from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/activeLicense.svg?react';
import { StepType } from '@/modules/adjusterReportModules/IncidentParticipants/components/common/Stepper.type';
import { ADJUSTER_REPORT_BODY_DAMAGE_PATHS } from '@/modules/adjusterReportModules/adjusterReport/links/bodyDamage/bodyDamageLinks';
export const bodyStepDriverData: StepType[] = [
  {
    label: 'اطلاعات فردی',
    icon: <NotActiveinitialInfo />,
    activeIcon: <ActiveinitialInfo />,
    path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.INFORMATION.DRIVER_OWNER.EDIT.driver,
  },
  {
    label: 'اطلاعات گواهینامه',
    icon: <NotActiveLicense />,
    activeIcon: <ActiveLicense />,
    path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.INFORMATION.DRIVER_OWNER.EDIT
      .certificate,
  },
  {
    label: 'اطلاعات تماس',
    icon: <NotActiveContact />,
    activeIcon: <ActiveContact />,
    path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.INFORMATION.DRIVER_OWNER.EDIT
      .driverContact,
  },
];
